export { getClientCreatedDateForDateRange } from './date-helpers';

/**
 * Returns the best display image URL for an Instagram post's media.
 * Uses thumbnailUrl for videos, url for images.
 */
export function getInstagramPostDisplayImage(media?: {
  mediaType?: string;
  thumbnailUrl?: string | null;
  url?: string | null;
}): string | null {
  if (!media) return null;
  // Prefer thumbnail for video, otherwise url
  return media.thumbnailUrl || media.url || null;
}
